import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action, set, setProperties } from '@ember/object';
import { dropTask, restartableTask } from 'ember-concurrency';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { closeModal, showModal } from 'sh-www/utils/modal-controls';
import AdminRecordPaymentModal from 'sh-www/components/modals/reports/admin-record-payment-modal';

class AdminProductionsViewIndexController extends Controller {
  @service router;
  @service api;
  @service store;
  @service session;

  contact = '';
  email = '';
  amount = '';
  memo = '';
  errors = { };

  get isSuperAdmin() {
    return this.session.currentUser.superAdmin;
  }

  @action
  handleInput(field, value) {
    set(this, field, value);

    if (this.errors[field]) {
      set(this.errors, field, undefined);
    }
  }

  @action
  navigateToAssignment(assignment) {
    this.router.transitionTo('posting', assignment.slug);
  }

  @action
  navigateToProject(project) {
    this.router.transitionTo('project-details', project.id);
  }

  @action
  recordPayment(production, shGeneralInvoice) {
    showModal(this, AdminRecordPaymentModal, {
      shGeneralInvoice,
      onComplete: async () => {
        try {
          await this.loadInvoices.perform(production);
        } catch {
          return;
        }
        closeModal(this);
      },
    });
  }

  @dropTask()
  *createInvoice(production, e) {
    e.preventDefault();

    set(this, 'errors', { });

    try {
      const { contact, email, amount, memo } = this;

      yield this.api.post(`productions/${production.id}/invoice`, {
        jsonData: {
          contact,
          email,
          amount: Math.trunc(Number.parseFloat(amount) * 100),
          memo: memo || null,
        },
      });
    } catch (e) {
      handleErrorResponse(this, e, ['contact', 'email', 'amount', 'memo']);
      return;
    }

    try {
      yield this.loadInvoices.perform(production);
    } catch {
      // do nothing
    }

    setProperties(this, {
      contact: '',
      email: '',
      amount: '',
      memo: '',
    });
  }

  @restartableTask
  *loadInvoices(production) {
    this.store.pushPayload(
      yield this.api.get(`productions/${production.id}`, {
        params: {
          include: 'invoices',
        },
      }),
    );
  }
}

export default AdminProductionsViewIndexController;
